import React from "react";

import { LengthInputSelector } from "@editor/components/editor/page/element-editor/components/modifiers/LengthInputModifier";
import OpacityIcon from "@svg/modifiers/opacity-icon";

import { ChevronDown } from "lucide-react";
import { parseUnit } from "replo-runtime/shared/utils/units";

const OPACITY_OPTIONS = [
  { label: "0%", value: "0" },
  { label: "25%", value: "25" },
  { label: "50%", value: "50" },
  { label: "75%", value: "75" },
  { label: "100%", value: "100" },
];

interface OpacitySelectorProps {
  opacity: number | null;
  onSelect: (opacity: number) => void;
}

const OpacitySelector: React.FC<OpacitySelectorProps> = ({
  opacity,
  onSelect,
}) => {
  const opacityDisplayValue = opacity != null ? `${opacity}%` : "100%";

  const handleOpacityInputChange = (newValue: string) => {
    const result = parseUnit(
      newValue,
      { value: 100, unit: "%" },
      "default",
      "%",
    );
    const numericValue = Number(result.value);
    if (
      !Number.isFinite(numericValue) ||
      numericValue < 0 ||
      numericValue > 100
    ) {
      return;
    }
    onSelect(numericValue);
  };

  return (
    <div className="opacity-selector">
      <LengthInputSelector
        field="opacity"
        value={opacityDisplayValue}
        onChange={handleOpacityInputChange}
        placeholder="100%"
        metrics={["%"]}
        unitDefaults={{ value: "100", unit: "%" }}
        menuOptions={OPACITY_OPTIONS}
        inputClassName="w-full"
        startEnhancer={<OpacityIcon className="w-3 h-3" />}
        endEnhancer={() => <ChevronDown size={12} />}
      />
    </div>
  );
};

export default OpacitySelector;
